import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";

// Restricts access to users that are logged in regardles of user groups
// Use AccessControl for further access control
export function RedirectToLogin() {
  const auth = useOktaAuth();
  const isAuthenticated = auth.authState?.isAuthenticated;
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  return <>{isAuthenticated === true ? <Outlet /> : null}</>;
}
